export const WarningCircleIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <rect x='5.5' y='5.5' width='13' height='13' rx='6.5' stroke='currentColor' />
    <path
      d='M11.9874 16.2909C11.2554 16.2909 10.7754 15.7509 10.7754 15.1029C10.7754 14.4669 11.2554 13.9389 11.9874 13.9389C12.7074 13.9389 13.2234 14.4669 13.2234 15.1029C13.2234 15.7509 12.7074 16.2909 11.9874 16.2909ZM11.1954 7.71094H12.7914L12.5154 13.0509H11.4714L11.1954 7.71094Z'
      fill='currentColor'
    />
  </svg>
)
